export var EventEndpoints;
(function (EventEndpoints) {
    EventEndpoints["TEXT"] = "/text";
    EventEndpoints["IMAGE"] = "/image";
    EventEndpoints["CHOICE"] = "/choice";
    EventEndpoints["CONVERSATION_START"] = "/conversation-start";
    EventEndpoints["CONVERSATION_END"] = "/conversation-end";
    EventEndpoints["MEDIA"] = "/media";
})(EventEndpoints || (EventEndpoints = {}));
